import gql from 'graphql-tag';
import { serverError } from 'src/utils';
import { apollo } from 'src/features';
import getClientCard from './getClientCard';

const mutation = gql`
mutation updateCustomer($id: Int!, $updateCustomerInput: UpdateCustomerInput!) {
  updateCustomer(id: $id, input: $updateCustomerInput) {
    id
  }
}`;

const fieldsName = {
  first_name: 'T_FIRST_NAME',
};

function onParseErrors(item) {
  return serverError.interpolation(item, fieldsName);
}

export default function updateOmniCustomer({
  id,
  firstName,
  lastName,
  middleName,
  birthdate,
  gender,
  vip,
  comment,
}, userRole, isExternalOperator = false) {
  const customerId = parseInt(id, 10);
  const newCustomerInput = isExternalOperator
    ? {
      firstName,
      vip,
      comment,
    } : {
      firstName,
      lastName,
      middleName,
      birthdate,
      gender: gender ? gender.toUpperCase() : gender,
      vip,
      comment,
    };
  return apollo.client.mutate({
    mutation,
    variables: {
      id: customerId,
      updateCustomerInput: newCustomerInput,
    },
  })
    .catch((err) => {
      if (err.graphQLErrors.length) {
        const errors = err.graphQLErrors[0].error.payload;
        throw errors.map(onParseErrors);
      } else {
        throw err;
      }
    })
    .then(() => getClientCard(customerId, userRole, isExternalOperator))
    .then((res) => res.omniCustomer);
}
